import { useState, useEffect, useRef, useCallback } from "react";
import { cn } from "@/lib/utils";

const LOGO_TEXT = "Komoran";

export function KomoranIcon({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className={className}>
      <path fill="currentColor" d="m9.775 17.9 -1.675 4.025 -1.375 -0.575 1.5 -3.625c-1.83335 -0.4 -3.329165 -1.32915 -4.4875 -2.7875C2.579165 13.47915 2 11.81665 2 9.95v-4.125c0 -1.066665 0.375 -1.970835 1.125 -2.7125S4.783335 2 5.85 2c0.28335 0 0.55835 0.033335 0.825 0.1 0.26665 0.066665 0.53335 0.158335 0.8 0.275l5.85 2.425 -3.65 1.35v1.9l8.25 5.25H9.95c-0.75 0 -1.39585 -0.2375 -1.9375 -0.7125 -0.54165 -0.475 -0.8125 -1.07085 -0.8125 -1.7875h-1.5c0 1.13335 0.42085 2.08335 1.2625 2.85 0.84165 0.76665 1.8375 1.15 2.9875 1.15h10.35l0.7 0.45 1 4.75h-2l-0.95 -2.1H13.8V22h-1.5v-4.1h-2.525ZM5.85 5.1c-0.21665 0 -0.39585 0.07085 -0.5375 0.2125s-0.2125 0.32085 -0.2125 0.5375c0 0.21665 0.07085 0.39585 0.2125 0.5375s0.32085 0.2125 0.5375 0.2125c0.21665 0 0.39165 -0.07085 0.525 -0.2125 0.13335 -0.14165 0.2 -0.32085 0.2 -0.5375 0 -0.21665 -0.06665 -0.39585 -0.2 -0.5375 -0.13335 -0.14165 -0.30835 -0.2125 -0.525 -0.2125Z" />
    </svg>
  );
}

export function KomoranLogo({ className }: { className?: string }) {
  const [display, setDisplay] = useState(LOGO_TEXT.replace(/./g, " "));
  const frameRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const decode = useCallback(() => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let resolved = 0;
    let tick = 0;

    const step = () => {
      tick++;
      const arr: string[] = [];
      for (let i = 0; i < LOGO_TEXT.length; i++) {
        if (i < resolved) {
          arr.push(LOGO_TEXT[i]!);
        } else {
          arr.push(chars[Math.floor(Math.random() * chars.length)]!);
        }
      }
      if (tick % 5 === 0 && resolved < LOGO_TEXT.length) {
        resolved++;
      }
      setDisplay(arr.join(""));
      if (resolved <= LOGO_TEXT.length) {
        frameRef.current = setTimeout(step, 70);
      }
    };
    step();
  }, []);

  useEffect(() => {
    decode();
    return () => clearTimeout(frameRef.current);
  }, []);

  return (
    <div className={cn("flex items-center gap-2 select-none cursor-default", className)}>
      <KomoranIcon className="h-5 w-5" />
      <span className="text-sm font-medium tabular-nums">
        {display}
      </span>
    </div>
  );
}
